'use client';

// TODO: будущая задача (все что в комменте это для будущей задачи)
import React from 'react';
import { useTranslations } from 'next-intl';
import { Link, usePathname } from '@/navigation';
import { classNames } from '@/shared/lib/classnames/classnames';
import { Button } from '@/shared/ui/button';

// import { DoctorRecommendation } from './DoctorRecommendation';

import { DoctorRecommendation } from './DoctorRecommendation';
import type { ITextDataRecommendation } from '@/entities/common/types/recommendations';
import type { IDoctorDetails, IDoctor } from '@/entities/doctor/model/types';
interface Props {
  doctor: IDoctorDetails;
  initialRecommendation: IDoctor[];
  initialTextData: ITextDataRecommendation;
}

// async function getData(options: GetRecommendationsOptions) {
//   const query = getQueryForRecommendations(options);
//   const recommendation = await DoctorRepository.getRecommendationsDoctor(query);

//   return {
//     recommendation: recommendation.list,
//     textData: recommendation.textData,
//   };
// }

export const RecommendationListClient: React.FC<Props> = ({
  doctor,
  initialRecommendation,
  initialTextData
}) => {
  // const { medcenterId } = useDoctor();
  const pathname = usePathname();
  // const [recommendation, setRecommendation] = useState<IDoctor[]>(initialRecommendation);
  // const [textData, setTextData] = useState<ITextDataRecommendation>(initialTextData);
  const t = useTranslations();
  const getHrefSearch = () => {
    const data = pathname.split('/').filter(Boolean);
    const skill = doctor.skills?.length ? doctor.skills[0].alias : null;
    let url = '';
    if (data.includes('kk')) {
      url = `/kk/${data[1]}/doctors/`;
    } else {
      url = `/${data[0]}/doctors/`;
    }
    if (skill) {
      url += skill;
    }
    return url;
  };

  // useEffect(() => {
  //   const fetchRecommendations = async () => {
  //     if (medcenterId) {
  //       const { recommendation, textData } = await getData({
  //         isBanned: doctor.isBanned,
  //         isStar: doctor.isStar,
  //         medcenterId: doctor.medcenters?.length ? doctor.medcenters[0].id : null,
  //         skillId: doctor.skills?.length ? doctor.skills[0].id : null,
  //         ignoredDoctorId: doctor.id,
  //       });

  //       setRecommendation(recommendation);
  //       setTextData(textData);
  //     }
  //   };

  //   fetchRecommendations();
  // }, [medcenterId]);

  return <div className={classNames('w-full rounded-2xl bg-bgPrimary p-4', {
    'mt-4': doctor.isBanned
  })} data-sentry-component="RecommendationListClient" data-sentry-source-file="RecommendationListClient.tsx">
      {!doctor.isBanned ? <h2 className="mb-6 text-center">{initialTextData.title}</h2> : <>
          <h2 className="mb-2 text-center text-lg">{t('doctor.recommendation.ban_title')}</h2>
          <h4 className="mb-2 text-center text-base">{t('doctor.recommendation.ban_desc')}</h4>
        </>}
      <div className="space-y-4">
        {initialRecommendation.map(recommendedDoctor => <DoctorRecommendation key={recommendedDoctor.id} recommendedDoctors={[recommendedDoctor]} currentSkill={doctor.skills.length > 0 ? doctor.skills[0] : null} />)}
      </div>
      <Button variant={'secondary-main'} textWeight={'bold'} className="mt-4 w-full whitespace-break-spaces py-3 text-center" data-sentry-element="Button" data-sentry-source-file="RecommendationListClient.tsx">
        <Link href={getHrefSearch()} data-sentry-element="Link" data-sentry-source-file="RecommendationListClient.tsx">{initialTextData.button}</Link>
      </Button>
    </div>;
};